import { ChevronRightIcon } from "@/components/Icons/ChevronRightIcon";
import { Button } from "@/design-system/Button";
import { Divider } from "@/design-system/Divider";
import { Spread } from "@/design-system/Spread";
import { Stack } from "@/design-system/Stack";

type NotificationSettingsTableItem =
  | {
      label: string;
      renderOption: () => React.ReactNode;
      href?: never;
    }
  | {
      label: string;
      href: string;
      renderOption?: never;
    };

type NotificationSettingsTableProps = {
  items: NotificationSettingsTableItem[];
};

export function NotificationSettingsTable({ items }: NotificationSettingsTableProps): React.ReactNode {
  return (
    <Stack gap="md">
      <Divider />
      {items.map((item) => {
        if (item.href !== undefined) {
          return (
            <Button key={item.label} type="link" href={item.href} variant="ghostSecondary" size="sm" fullWidth>
              <span className="grow text-start text-body-emphasis">{item.label}</span>
              <ChevronRightIcon />
            </Button>
          );
        }

        return (
          <Spread key={item.label} space="xs" align="center">
            <span className="text-body-emphasis">{item.label}</span>
            {item.renderOption()}
          </Spread>
        );
      })}
    </Stack>
  );
}
